// extracted by mini-css-extract-plugin
module.exports = {"availability":"StoreAvailabilityInfo_availability__N1oK3","schedule":"StoreAvailabilityInfo_schedule__AOift","scheduleText":"StoreAvailabilityInfo_scheduleText__d6YO6"};